import { Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { AzureMapsService } from '../../services/azure-maps.service';
import { CityService } from '../../services/city.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import { OpenLayersMap } from '../map/openlayers-map.component';
import {
    City,
    Country,
    EpiTimeZone,
    GeoCoordinate,
    //Market,
    //Region,
    //SearchCityState,
    SearchZip3,
    State as StateProvince,
    //Zip3
} from '../../models/models';

@Component({
    selector: 'city-form',
    templateUrl: './city-form.component.html',
    standalone: false
})
export class CityForm implements OnInit {
    @Output() citySelected = new EventEmitter<any>();
    @Output() cityBlurred = new EventEmitter<any>();

    @ViewChild('olMap') olMapComponent!: OpenLayersMap;

    public city: City = {} as City;

    public countryList: Country[] = [];
    //public regionList: Region[] = [];
    //public origMarketList: Market[] = [];
    //public marketList: Market[] = [];
    public stateList: StateProvince[] = [];
    //private zip3List: Zip3[] = [];
    public searchZip3: SearchZip3 = {} as SearchZip3;
    public countryID: number = 0;
    public stateID: number = 0;
    //public marketID: number = 0;
    //public cityID: number = 0;
    //public zip3: string = "";
    public address: string = "";
    public streetNumber: string = "";
    public streetName: string = "";
    public cityName: string = "";
    public stateName: string = "";
    public postalCode: string = "";
    public countryCode: string = "";
    public geoCoord: GeoCoordinate = {} as GeoCoordinate;
    public timeZone: EpiTimeZone = {} as EpiTimeZone;
    public zipOverride: string = "";
    public stateIDOverride: number = 0;
    private zip3: string = "";
    private missingFields: string = "";

    //public cities: SearchCityState[] = [];
    //public citiesStartsWith: Array<string> = [];
    //public cityStateZipList: SearchCityState[] = [];
    //public selectedCityST: string = "";
    //public selectedCityID: number = 0;
    //public ariaLabel: string = "";
    //public isError: boolean = false;
    //public isValidTimeZone: boolean = true;
    //public timeZoneName: string = "";
    //public cityLatitude: number = 0;
    //public cityLongitude: number = 0;
    //public errorDetail: string = "";

    constructor(private azureMapsService: AzureMapsService, private applicationControlService: ApplicationControlService,
        private cityService: CityService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        //this.streetNumber = "6";
        //this.streetName = "Chome-6-2 Nishishinjuku";
        //this.cityName = "Shinjuku City";
        //this.postalCode = "160-0023";
        this.getCountries();
        //this.getRegions();
        //this.getMarkets();
    }

    //ngOnChanges(changes: SimpleChanges) {
    //}

    private initFields() {
        //this.countryID = 0;
        //this.stateID = 0;
        //this.marketID = 0;
        //this.cityID = 0;
        //this.zip3 = "";
        this.searchZip3 = {} as SearchZip3;
        this.city.countryID = 0;
        this.city.regionID = 0;
        this.city.stateID = 0;
        this.city.marketID = 0;
        this.city.zip3 = "";
        this.city.cityID = 0;
        this.city.erpCityID = 0;
        //this.zipOverride = "";
        this.missingFields = "";
    }

    private getCountries() {
        this.utilService.isLoading = true;
        this.cityService.getCountries().subscribe(result => {
            this.utilService.isLoading = false;
            this.countryList = result;
            for (var i = 0; i < this.countryList.length; i++) {
                this.countryList[i].abbrev = this.countryList[i].abbrev.trim().toUpperCase();
            }
            var usa = this.countryList.find(t => t.abbrev == "US");
            var others = this.countryList.filter(t => t.abbrev != "US");
            this.countryList = others.sort((left, right): number => {
                if (left.abbrev < right.abbrev) return -1;
                if (left.abbrev > right.abbrev) return 1;
                return 0;
            });
            this.countryList.unshift(usa!);
            ////this.countryList = this.countryList.filter(t => t.abbrev == "US" || t.abbrev == "MX" || t.abbrev == "CA")
            //var country = this.countryList.find(t => t.abbrev == "US");
            //if (country != null && country.countryId > 0) {
            //    this.countryID = country.countryId;
            //    this.getStates();
            //}
        });
    }

    public getGeocodeFromFullAddress() {
        if (this.address.trim().length > 0) {
            this.utilService.isLoading = true;
            this.azureMapsService.getGeoCoordinateByFullAddress(encodeURIComponent(this.address)).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    this.geoCoord = result.resultCollection[0];
                    if (this.geoCoord.longitude != 0 && this.geoCoord.longitude != 0) {
                        this.setCityFromGeoCoordinate();
                        if (this.geoCoord.cityName == null || this.geoCoord.cityName == "") {
                            this.getGeocodeFromLatLon();
                        }
                        else {
                            this.getTimeZoneFromLatLon();
                        }
                    }
                    else {
                        this.notificationService.showWarning("Address has no results.", "WARNING: Address Search");
                    }
                }
                else {
                    this.notificationService.showWarning("Address has no results.", "WARNING: Address Search");
                }
                console.log("getGeocodeFromFullAddress", result, this.geoCoord);
            });
        }
    }

    public getGeocodeFromStructuredAddress() {
        if (this.cityName.trim().length > 0 && this.stateName.trim().length > 0 && this.postalCode.trim().length > 0 && this.countryCode.trim().length > 0) {
            this.utilService.isLoading = true;
            this.azureMapsService.getGeoCoordinateByStructuredAddress(
                encodeURIComponent(this.streetNumber.trim()),
                encodeURIComponent(this.streetName.trim()),
                encodeURIComponent(this.cityName.trim()),
                encodeURIComponent(this.stateName.trim()),
                encodeURIComponent(this.postalCode.trim()),
                encodeURIComponent(this.countryCode.trim())
            ).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    this.geoCoord = result.resultCollection[0];
                    if (this.geoCoord.longitude != 0 && this.geoCoord.longitude != 0) {
                        this.setCityFromGeoCoordinate();
                        this.getTimeZoneFromLatLon();
                    }
                    else {
                        this.notificationService.showWarning("Address has no results.", "WARNING: Address Search");
                    }
                }
                else {
                    this.notificationService.showWarning("Address has no results.", "WARNING: Address Search");
                }
                console.log("getGeocodeFromFullAddress", result, this.geoCoord);
            });
        }
    }

    public getGeocodeFromLatLon() {
        if (this.city.latitude != 0 && this.city.longitude != 0) {
            this.utilService.isLoading = true;
            this.azureMapsService.getGeoCoordinateByLatLon(this.city.latitude, this.city.longitude).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    this.geoCoord = result.resultCollection[0];
                    if (this.geoCoord.longitude != 0 && this.geoCoord.longitude != 0) {
                        this.setCityFromGeoCoordinate();
                    }
                    else {
                        this.notificationService.showWarning("Lat/Lon has no results.", "WARNING: Lat/Lon Search");
                    }
                }
                else {
                    this.notificationService.showWarning("Lat/Lon has no results.", "WARNING: Lat/Lon Search");
                }
                console.log("getCityFromLatLon", result, this.geoCoord);
            });
            this.getTimeZoneFromLatLon();
        }
    }

    public getTimeZoneFromLatLon() {
        if (this.city.latitude != 0 && this.city.longitude != 0) {
            this.utilService.isLoading = true;
            this.azureMapsService.getTimeZoneByLatLon(this.city.latitude, this.city.longitude).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    this.timeZone = result.resultCollection[0];
                    this.city.epiTimeZoneID = this.timeZone.epiTimeZoneID;
                }
                else {
                    this.notificationService.showWarning("No timezone results found.", "WARNING: Timezone");
                }
                console.log("getTimeZoneFromLatLon", result, this.timeZone);
            });
        }
    }

    private getSearchZip3(searchType: string, searchValue: string) {
        if (searchType == "zip3") {
            console.log("getSearchZip3:zip3", searchType, searchValue);
            this.utilService.isLoading = true;
            this.cityService.getSearchZip3ByZip3(searchValue).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length == 1) {
                    this.searchZip3 = result.resultCollection[0];
                    this.setCityFromSearchZip3();
                }
                else {
                    this.notificationService.showWarning("Zip3 not found. Please modify the address or Lat/Lon coordinates. Zip3: " + this.zip3, "WARNING: Zip3 Not Found");
                }
                console.log("getSearchZip3:zip3", searchType, searchValue, result);
            });
        }
        else if (searchType == "Mexico") {
            var country = this.countryList.find(t => t.name == searchType);
            console.log("getSearchZip3:mexico", searchType, searchValue, country);
            if (country != null) {
                this.utilService.isLoading = true;
                this.cityService.getSearchZip3ByCountryIDZipMinMax(searchValue, country.countryId).subscribe(result => {
                    this.utilService.isLoading = false;
                    if (result.resultCollection.length == 1) {
                        this.searchZip3 = result.resultCollection[0];
                        this.setCityFromSearchZip3();
                    }
                    else {
                        this.notificationService.showWarning("Zip3 not found. Please modify the address or Lat/Lon coordinates. Zip3: " + this.zip3, "WARNING: Zip3 Not Found");
                    }
                    console.log("getSearchZip3:mexico", searchType, searchValue, result);
                });
            }
        }
        else if (searchType == "country") {
            var country = this.countryList.find(t => t.name == searchValue);
            console.log("getSearchZip3:country", searchType, searchValue, country);
            if (country != null) {
                this.utilService.isLoading = true;
                this.cityService.getSearchZip3ByCountryID(country.countryId).subscribe(result => {
                    this.utilService.isLoading = false;
                    if (result.resultCollection.length == 1) {
                        this.searchZip3 = result.resultCollection[0];
                        this.setCityFromSearchZip3();
                    }
                    else {
                        this.notificationService.showWarning("Zip3 not found. Please modify the address or Lat/Lon coordinates. Zip3: " + this.zip3, "WARNING: Zip3 Not Found");
                    }
                    console.log("getSearchZip3:country", searchType, searchValue, result);
                });
            }
        }
    }

    private setCityFromGeoCoordinate() {
        this.initFields();
        this.city.name = this.geoCoord.cityName;
        this.city.zip = this.geoCoord.zip;
        this.city.latitude = this.geoCoord.latitude;
        this.city.longitude = this.geoCoord.longitude;
        this.city.county = "";
        this.city.frequency = 1;
        this.city.useCityForDupCitySTZip3Ind = true;
        this.city.defaultCityStateRecord = true;
        this.city.createdFrom = "Web City Form";
        this.city.createdByEmployeeId = localStorage.getItem('EmployeeId') == null ? -1 : parseInt(localStorage.getItem('EmployeeId')!);

        if (this.geoCoord.country == "United States" || this.geoCoord.country == "Canada") {
            if (this.geoCoord.zip != null && this.geoCoord.zip != "") {
                this.zip3 = this.geoCoord.zip.substring(0, 3);
                this.getSearchZip3("zip3", this.zip3);
            }
            //else if (this.geoCoord.cityName != null && this.geoCoord.cityName != "") {
            //}
            //else if (this.geoCoord.state != null && this.geoCoord.state != "") {
            //}
        }
        else if (this.geoCoord.country == "Mexico") {
            if (this.geoCoord.zip != null && this.geoCoord.zip != "") {
                this.getSearchZip3("Mexico", this.geoCoord.zip);
            }
            //else if (this.geoCoord.cityName != null && this.geoCoord.cityName != "") {
            //}
            //else if (this.geoCoord.state != null && this.geoCoord.state != "") {
            //}
        }
        else {
            this.getSearchZip3("country", this.geoCoord.country);
        }

        this.olMapComponent.addSingleLatLon(this.geoCoord.latitude, this.geoCoord.longitude);

        console.log("setCityFromGeoCoordinate", this.zip3, this.city, this.geoCoord);

        //var countries = this.countryList.filter(t => t.name == this.geoCoord.country);
        //if (countries.length == 1) {
        //    this.countryID = countries[0].countryId;
        //    this.city.countryID = countries[0].countryId;
        //    this.countryChanged(countries[0].countryId);
        //}
        //var regions = this.regionList.filter(t => t.name == this.geoCoord.country);
        //if (regions.length == 1) {
        //    this.city.regionID = regions[0].regionID;
        //}
    }

    private setCityFromSearchZip3() {
        this.city.countryID = this.searchZip3.countryID;
        this.city.regionID = this.searchZip3.regionID;
        this.city.stateID = this.searchZip3.stateID;
        this.city.marketID = this.searchZip3.marketID;
        this.city.countryName = this.searchZip3.countryName;
        this.city.stAbbr = this.searchZip3.stateAbbrev;
        this.setCitySTZip();
        this.city.zip3 = this.searchZip3.zip3;
        this.countryID = this.searchZip3.countryID;
        this.getStates();
    }

    private setCitySTZip() {
        var stateAbbr: string = this.searchZip3.stateAbbrev;
        if (this.stateIDOverride > 0) {
            var state = this.stateList.find(t => t.stateId == this.stateIDOverride);
            if (state != null) {
                stateAbbr = state.abbrev.trim();
                this.city.stateID = state.stateId;
                this.city.stAbbr = stateAbbr;
                this.city.cityST = this.geoCoord.cityName + "," + stateAbbr;
            }
        }
        else {
            this.city.cityST = this.geoCoord.cityName + "," + this.searchZip3.stateAbbrev;
        }
        if (this.zipOverride != "") {
            this.city.cityStateZip = this.city.cityST + " " + this.zipOverride;
            this.city.zip = this.zipOverride;
        }
        else {
            this.city.cityStateZip = this.city.cityST + " " + this.searchZip3.minZip;
        }
    }

    public canOverrideStateID() {
        if ((this.geoCoord.state == '' || this.geoCoord.state == null) && this.geoCoord.country != '' || this.stateIDOverride > 0) {
            return true;
        }
        else if (this.geoCoord.state != '' && this.geoCoord.state != null && this.city.stateID == -1) {
            return true;
        }
        else {
            return false;
        }
    }

    public canOverrideZip() {
        if ((this.geoCoord.zip == '' || this.geoCoord.zip == null) && this.geoCoord.country != '') {
            return true;
        }
        else {
            return false;
        }
    }

    public stateIDOverrideChanged() {
        this.setCitySTZip();
    }

    public zipOverrideChanged() {
        this.setCitySTZip();
    }

    public canSaveCity() {
        var isValid: boolean = true;
        this.missingFields = "";
        if (this.city.countryID == null || this.city.countryID == 0) {
            isValid = false;
            this.missingFields += "Country, ";
        }
        if (this.city.regionID == null || this.city.regionID == 0) {
            isValid = false;
            this.missingFields += "Region, ";
        }
        if (this.city.stateID == null || this.city.stateID == 0) {
            isValid = false;
            this.missingFields += "State/Province, ";
        }
        if (this.city.marketID == null || this.city.marketID == 0) {
            isValid = false;
            this.missingFields += "Market, ";
        }
        if (this.city.name == null || this.city.name.trim() == "") {
            isValid = false;
            this.missingFields += "City, ";
        }
        if (this.city.stAbbr == null || this.city.stAbbr.trim() == "") {
            isValid = false;
            this.missingFields += "State/Province Abbr, ";
        }
        if (this.city.cityST == null || this.city.cityST.trim() == "") {
            isValid = false;
            this.missingFields += "City State, ";
        }
        if (this.city.countryName == null || this.city.countryName.trim() == "") {
            isValid = false;
            this.missingFields += "Country Name, ";
        }
        if (this.city.zip3 == null || this.city.zip3.trim() == "") {
            isValid = false;
            this.missingFields += "Zip3, ";
        }
        if (this.city.zip == null || this.city.zip.trim() == "") {
            isValid = false;
            this.missingFields += "Zip, ";
        }
        if (this.city.latitude == null || this.city.latitude == 0) {
            isValid = false;
            this.missingFields += "Latitude, ";
        }
        if (this.city.longitude == null || this.city.longitude == 0) {
            isValid = false;
            this.missingFields += "longitude, ";
        }
        if (this.missingFields.length > 0) {
            this.missingFields = this.missingFields.substring(0, this.missingFields.length - 2);
        }
        return isValid;
    }

    public saveCity() {
        if (this.canSaveCity()) {
            this.utilService.isLoading = true;
            //var nowDate = this.utilService.getDateAsUTC(new Date());
            this.cityService.getCityByCityStateIDZip(this.city.name, this.city.stateID, this.city.zip).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length == 0) {
                    this.utilService.isLoading = true;
                    //var nowDate = this.utilService.addSeconds(new Date(), -5);
                    this.cityService.saveCity(this.city).subscribe(result2 => {
                        this.utilService.isLoading = false;
                        if (result2.resultCollection.length == 1) {
                            var city: City = result2.resultCollection[0];
                            this.notificationService.showSuccess("City successfully added", "SUCCESS: City Added");
                            this.clearForm();
                            //var createdDate = new Date(1969, 12, 31);
                            //if (city.createdDate != null) {
                            //    //createdDate = new Date(this.utilService.getUTCDateAsLocalDate(new Date(city.createdDate)));
                            //    createdDate = this.utilService.getTimeZoneDateAsLocalDate(new Date(city.createdDate), "UTC");
                            //}
                            //if (createdDate < nowDate) {
                            //    this.notificationService.showWarning("City already added on" + createdDate.toLocaleString(), "WARNING: City Already Exists");
                            //}
                            //else {
                            //    this.clearForm();
                            //}
                            //console.log("saveCity", createdDate, nowDate, this.city, result);
                        }
                        else {
                            this.notificationService.showError("Error adding city. Please double-check the proper address or lat/lon values.", "ERROR: Add City");
                        }
                    });
                }
                else {
                    this.notificationService.showWarning("City already exists", "WARNING: City Already Exists");
                }
            });
        }
        else {
            this.notificationService.showWarning("Missing required fields (" + this.missingFields + "). Please complete the form.", "WARNING: Required Fields");
        }
    }

    public clearForm() {
        this.geoCoord = {} as GeoCoordinate;
        this.timeZone = {} as EpiTimeZone;
        this.city = {} as City;
        this.address = ""
        this.streetNumber = "";
        this.streetName = "";
        this.cityName = "";
        this.stateName = "";
        this.postalCode = "";
        this.countryCode = "";
        this.stateIDOverride = 0;
        this.zipOverride = "";
        this.initFields();
    }

    public setCoordinate(coordinate: number[]) {
        if (coordinate.length == 2) {
            this.city.longitude = coordinate[0];
            this.city.latitude = coordinate[1];
        }
    }

    //private getRegions() {
    //    this.utilService.isLoading = true;
    //    this.cityService.getRegions().subscribe(result => {
    //        this.utilService.isLoading = false;
    //        this.regionList = result.resultCollection;
    //        this.regionList = this.regionList.sort((left, right): number => {
    //            if (left.name < right.name) return -1;
    //            if (left.name > right.name) return 1;
    //            return 0;
    //        });
    //    });
    //}

    private getStates() {
        this.utilService.isLoading = true;
        this.cityService.getStatesByCountryID(this.countryID).subscribe(result => {
            this.utilService.isLoading = false;
            this.stateList = result.resultCollection;
            this.stateList = this.stateList.sort((left, right): number => {
                if (left.name < right.name) return -1;
                if (left.name > right.name) return 1;
                return 0;
            });
            if (this.geoCoord.state) {
                this.geoCoord.state = this.geoCoord.state.trim();
                var state = this.stateList.find(t => t.name == this.geoCoord.state);
                if (state != null) {
                    this.stateID = state.stateId;
                    //this.city.stateID = state.stateId;
                    //this.stateChanged(state.stateId);
                }
            }
        });
    }

    //private getMarkets() {
    //    this.utilService.isLoading = true;
    //    this.cityService.getMarkets().subscribe(result => {
    //        this.utilService.isLoading = false;
    //        this.origMarketList = result.resultCollection;
    //        for (var i = 0; i < this.origMarketList.length; i++) {
    //            this.origMarketList[i].abbrev = this.origMarketList[i].abbrev.trim();
    //        }
    //        this.origMarketList = this.origMarketList.sort((left, right): number => {
    //            if (left.name < right.name) return -1;
    //            if (left.name > right.name) return 1;
    //            return 0;
    //        });
    //        this.marketList = this.origMarketList;
    //    });
    //}

    //private getZip3s(areaType: string) {
    //    if (areaType == "state" && this.city.stateID > 0) {
    //        this.utilService.isLoading = true;
    //        this.cityService.getZip3ByStateID(this.city.stateID).subscribe(result => {
    //            this.utilService.isLoading = false;
    //            this.zip3List = result.resultCollection;
    //            if (this.zip3List.length == 0) {
    //                this.getZip3s("market");
    //            }
    //            else if (this.zip3List.length == 1) {
    //                this.city.zip3 = this.zip3List[0].zip;
    //            }
    //        });
    //    }
    //    if (areaType == "market" && this.city.marketID > 0) {
    //        this.utilService.isLoading = true;
    //        this.cityService.getZip3ByMarketID(this.city.marketID).subscribe(result => {
    //            this.utilService.isLoading = false;
    //            this.zip3List = result.resultCollection;
    //            if (this.zip3List.length == 0) {
    //                this.getZip3s("region");
    //            }
    //            else if (this.zip3List.length == 1) {
    //                this.city.zip3 = this.zip3List[0].zip;
    //            }
    //        });
    //    }
    //    if (areaType == "region" && this.city.regionID > 0) {
    //        this.utilService.isLoading = true;
    //        this.cityService.getZip3ByRegionID(this.city.regionID).subscribe(result => {
    //            this.utilService.isLoading = false;
    //            this.zip3List = result.resultCollection;
    //            if (this.zip3List.length == 0) {
    //                this.getZip3s("country");
    //            }
    //            else if (this.zip3List.length == 1) {
    //                this.city.zip3 = this.zip3List[0].zip;
    //            }
    //        });
    //    }
    //    if (areaType == "country" && this.city.countryID > 0) {
    //        this.utilService.isLoading = true;
    //        this.cityService.getZip3ByCountryID(this.city.countryID).subscribe(result => {
    //            this.utilService.isLoading = false;
    //            this.zip3List = result.resultCollection;
    //            if (this.zip3List.length == 1) {
    //                this.city.zip3 = this.zip3List[0].zip;
    //            }
    //        });
    //    }
    //}

    public countryChanged(evt: any) {
        //if (!this.geoCoord.country) {
        //    this.initFields();
        //}
        //if (evt.target) {
        //    this.countryID = parseInt(evt.target.value);
        //}
        //else if (!isNaN(evt)) {
        //    this.countryID = evt;
        //}
        //if (this.countryID > 0) {
        //    this.city.countryID = this.countryID;
        //    this.marketList = this.origMarketList.filter(t => t.countryId == this.countryID);
        //    if (this.marketList.length == 1) {
        //        this.city.marketID = this.marketList[0].marketId;
        //    }
        //    this.getStates();
        //    this.getZip3s("country");
        //}
        if (this.countryCode != "") {
            var country = this.countryList.find(t => t.abbrev == this.countryCode);
            if (country != null) {
                this.countryID = country.countryId;
                this.getStates();
            }
        }
    }

    //public marketChanged(evt: any) {
    //    if (evt.target) {
    //        this.marketID = parseInt(evt.target.value);
    //    }
    //    else if (!isNaN(evt)) {
    //        this.marketID = evt;
    //    }
    //    else {
    //        this.marketID = 0;
    //    }
    //    if (this.marketID > 0) {
    //        this.city.marketID = this.marketID;
    //        this.getZip3s("market");
    //    }
    //}

    public stateChanged(evt: any) {
        //this.marketList = this.origMarketList;
        if (evt.target) {
            this.stateID = parseInt(evt.target.value);
        }
        else if (!isNaN(evt)) {
            this.stateID = evt;
        }
        else {
            this.stateID = 0;
        }
        if (this.stateID > 0) {
            var state = this.stateList.find(t => t.stateId == this.stateID);
            if (state != null && this.stateID > 0) {
                this.city.stateID = this.stateID;
                this.city.stAbbr = state.abbrev;
                this.stateName = state.name;
                //this.getZip3s("state");
                //this.marketList = this.origMarketList.filter(t => t.stateId == this.stateID);
                //if (this.marketList.length == 0) {
                //    this.marketList = this.origMarketList.filter(t => t.countryId == this.countryID);
                //}
                //if (this.marketList.length == 1) {
                //    this.city.marketID = this.marketList[0].marketId;
                //}
            }
        }
        else {
            this.stateID = 0;
            //this.zip3List = [];
        }
        console.log("stateChanged", evt, this.stateID, this.countryID, this.countryCode, this.city);
    }

    //public zip3Changed(evt: any) {
    //    if (evt.target) {
    //        this.zip3 = evt.target.value.trim();
    //    }
    //    else {
    //        this.zip3 = "";
    //    }
    //    if (this.zip3 != "") {
    //        var zip3 = this.zip3List.find(t => t.zip == this.zip3);
    //        if (zip3 != null) {
    //            this.city.zip3 = this.zip3;
    //        }
    //    }
    //    console.log("zip3Changed", this.zip3, this.city);
    //}

    //public getCityLookup(value: string) {
    //    //console.log("filterCustomers", value);
    //    this.utilService.isLoading = true;
    //    this.cityService.getSearchCityStateByCitySTStartsWith(value).subscribe(result => {
    //        this.utilService.isLoading = false;
    //        var lst: SearchCityState[] = result.resultCollection;
    //        lst = lst.sort((left, right): number => {
    //            if (left.cityST < right.cityST) return -1;
    //            if (left.cityST > right.cityST) return 1;
    //            return 0;
    //        });
    //        this.cities = lst;
    //    });
    //}

    //private checkTimeZone(searchCity: SearchCityState) {
    //    this.timeZoneName = searchCity.windowsRegistryTimeZoneName == null ? "" : searchCity.windowsRegistryTimeZoneName;
    //    if (searchCity.epiTimeZoneID > 0) {
    //        this.isValidTimeZone = true;
    //    }
    //    else {
    //        if (searchCity.latitude != null && searchCity.latitude != 0 && searchCity.longitude != null && searchCity.longitude != 0) {
    //            this.cityLatitude = searchCity.latitude;
    //            this.cityLongitude = searchCity.longitude;
    //        }
    //        this.isValidTimeZone = false;
    //    }
    //}

    //public updateTimeZone() {
    //    if (this.selectedCityID > 0 && this.cityLatitude != 0 && this.cityLongitude != 0) {
    //        this.utilService.isLoading = true;
    //        this.cityService.saveCityLatLonTimeZone(this.selectedCityID, this.cityLatitude, this.cityLongitude).subscribe(result => {
    //            this.utilService.isLoading = false;
    //            var city: City = result.resultCollection[0];
    //            this.timeZoneName = city.epiTimeZone.windowsRegistryTimeZoneName;
    //            this.isValidTimeZone = true;
    //        });
    //    }
    //}
}
